import React from 'react';
import { PlusOutlined } from '@ant-design/icons';

interface AddLineItemFABProps {
  onClick: () => void;
  disabled?: boolean;
}

/** Floating action button for adding line items on mobile */
export const AddLineItemFAB: React.FC<AddLineItemFABProps> = ({ onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    aria-label="Add line item"
    style={{
      position: 'fixed',
      bottom: 'max(24px, calc(16px + env(safe-area-inset-bottom)))',
      right: 16,
      width: 56,
      height: 56,
      borderRadius: '50%',
      backgroundColor: disabled ? '#9ca3af' : '#2563eb',
      color: '#ffffff',
      border: 'none',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: disabled ? 'not-allowed' : 'pointer',
      fontSize: 22,
      transition: 'background-color 0.2s',
    }}
  >
    <PlusOutlined />
  </button>
);
